module.exports = __webpack_public_path__ + "img/gram.a43352c8.png";